const SADBOY_THEME_KEY = 'sadboy-theme';
const SADBOY_THEME_MODES = new Set(['light', 'dark', 'system']);

const bindOnce = (element, key, event, handler) => {
  if (element.dataset[key] === 'true') return;
  element.addEventListener(event, handler);
  element.dataset[key] = 'true';
};

const applySadBoyTheme = (mode, persist = true) => {
  const nextMode = SADBOY_THEME_MODES.has(mode) ? mode : 'system';
  document.documentElement.dataset.sbTheme = nextMode;
  if (persist) {
    try { window.localStorage.setItem(SADBOY_THEME_KEY, nextMode); } catch (error) { /* storage is optional */ }
  }
  document.querySelectorAll('[data-sb-theme-choice]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.dataset.sbThemeChoice === nextMode));
  });
};

const initSadBoyTheme = () => {
  document.querySelectorAll('[data-sb-theme-choice]').forEach((button) => {
    bindOnce(button, 'sbThemeBound', 'click', () => {
      applySadBoyTheme(button.dataset.sbThemeChoice);
      button.closest('details')?.removeAttribute('open');
    });
  });
  applySadBoyTheme(document.documentElement.dataset.sbTheme, false);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSadBoyTheme, { once: true });
} else {
  initSadBoyTheme();
}

document.addEventListener('shopify:section:load', initSadBoyTheme);
